<template>
<div
  style="border: 1px solid rgba(0,0,0,0.2); padding: 15px; border-radius: 15px; position: relative"
  v-if="$rc.$state.isAuthActorSystemAdmin()"
>
  <p><b>System administrators only</b></p>

  <p>The welcome screen is showing because this organization is in the pre-launch state.  Before users in this organization may use RedChirp you need to activate the organization.</p>

  <div
    style="margin-top: 15px; margin-bottom: 15px; font-weight: 700;"
  >
    Tasks
  </div>

  <m-todo-bar
    v-for="(item, index) in profile.tasks"
    :key="'todo'+index"
    :label="$rc.pretty(item.type,'enum_welcome_task')"
    :state="item.state"
    :clickable="item.confirm_title != null || item.state_override"
    v-on:click="onClickToDo(item)"
  />

  <m-select-employee-endpoint-dialog
    ref="select-endpoint-dialog"
    v-on:select-endpoint="onSwitchEndpoint"
    :organization_id="profile.organization_account.organization_id"
  />

  <div
    style="margin-top: 15px; font-weight: 700;"
  >
    Actions
  </div>

  <m-list-buttons
      :items="list_button_items"
  />

  <m-welcome-screen-settings-dialog
    ref="settings-dialog"
    v-on:ok="onChangeSettings"
  />

  <div
    style="position: absolute; top: 0px; right: 0px"
  >
    <img 
        src="@/assets/monday-logo.png" 
        width="200px" 
        v-on:click="onClickMonday"
        style="cursor: pointer"
    />
  </div>

  <m-rc-crm-notes-dialog
    ref="view-notes-dialog"
  />
  
</div>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
      return {

        list_button_items: [
            { 'title': 'Provision', 'sub_title': 'Access the provision screen for this organization', 'icon': 'mdi-cloud-sync-outline', 'action': this.onClickProvision },
            { 'title': 'Notes', 'sub_title': 'View / create notes for this organization', 'icon': 'mdi-note-multiple-outline', 'action': this.onClickViewNotes },
            { 'title': 'Organization settings', 'sub_title': 'View or edit the settings for this organization', 'icon': 'mdi-domain', 'action': this.onClickOrganizationSettings },
            { 'title': 'Welcome screen settings', 'sub_title': 'Customize the welcome screen for this organization (sections that show etc.)', 'icon': 'mdi-cog-outline', 'action': this.onClickWelcomeScreenSettings },
            { 'title': 'View conversations for phone number', 'sub_title': 'Allows you test sending/receiving messages, payment requests, etc.', 'icon': 'mdi-comment-text-multiple-outline', 'action': this.onClickViewConversationsForOnePhoneNumber },
            { 'title': 'View campaign registration (TCR) information', 'sub_title': 'View the TCR brand and campaign registratin provided by the client', 'icon': 'mdi-information-variant-box-outline', 'action': this.onClickTCRCampaignRegistration },
            { 'title': 'Delete RedChirp Subscription Agreement Signature', 'sub_title': 'Delete the client\'s signature on the subscription agreement', 'icon': 'mdi-delete-outline', 'action': this.onClickDeleteSignatureSubscriptionAgreement },
            { 'title': 'Vendor Assessment Resource Center', 'sub_title': 'Helpful when customers are completeing vendor assessments (i.e. assessing compliance etc.)', 'icon': 'mdi-open-in-new', 'action': this.onClickVendorAssessment },
            { 'title': 'Activate this organization', 'sub_title': 'Places organization in the active state, use right before training', 'icon': 'mdi-play', 'action': this.onClickActivateOrganization },
        ],

      }
    },
    
    methods: {

      onClickVendorAssessment()
      {
        window.open('https://redchirp.com/vendor-assessment-resource-center', '_blank');
      },

      onClickViewNotes()
      {
        this.$refs['view-notes-dialog'].showDialog(this.profile.organization_account.organization_id);
      },

      onClickProvision()
      { 
        this.$router.push({
          'name': 'provision',
          'params' : {
            'organization_id': this.profile.organization_account.organization_id,
          }
        });
      },

      onClickActivateOrganization()
      {
        this.$rc.confirm({
          'title': 'Activate Organization',
          'body': 'Are you sure that you would like to move '+this.profile.organization_account.label+' from the pre-launch to the active state?',
          'btn_text_ok': 'Activate',
          'btn_text_cancel': 'Cancel',
          'on_ok': () => {
            this.doActivateOrganization();
          },
        });
      },

      onClickViewConversationsForOnePhoneNumber()
      {
        this.$refs['select-endpoint-dialog'].showDialog();
      },

      onClickWelcomeScreenSettings()
      {
        this.$refs['settings-dialog'].showDialog(this.profile);
      },

      onClickOrganizationSettings()
      {
        window.open(this.$router.resolve({
          'name': 'settings-organization',
          'params' : {
            'organization_id': this.profile.organization_account.organization_id,
          }
        }).href, '_blank');
      },

      doActivateOrganization()
      {
          this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/organizations/organization-account',
            
                'params' : {
                    'organization_id': this.profile.organization_account.organization_id,
                    'organization_state': 'active',
                    },
            
                'on_success': (data) => {
                        this.$router.push({
                          'name': 'home',
                        });
                    },
            
                'on_error': 'Unable to change organization state.',
            });
      },

      onSwitchEndpoint(endpoint)
      {
        this.$router.replace({
              'name': 'home-routed',
              'params' : {
                  'endpoint': E164.slimEndpoint(endpoint),
                  'conversation_id': 'none',
              }
          })
          .catch(e=>{});
      },

      onChangeSettings()
      {
        this.$emit('reload-profile');
      },

      onClickDeleteSignatureSubscriptionAgreement()
      {
        if ( this.profile.subscription_signature == null )
        {
          this.$rc.alert('Unable to delete signature', 'Unable to delete the subscription agreement signature because the client has not signed yet');
          return;
        }

        this.$rc.confirm({
          'title': 'Delete RedChirp subscription agreement signature',
          'body': 'Are you sure that you want to permentanlty delete the RedChirp subscription agreement signature for this organiztion?',
          'btn_text_ok': 'Delete',
          'btn_text_cancel': 'Cancel',
          'on_ok': () => {
            this.doDeleteSignatureSubscriptionAgreement();
          },
        });
      },

      doDeleteSignatureSubscriptionAgreement()
      {
        this.$rc.rest({
          'spinner': false,
          'endpoint': 'PUT: /api/v1/signatures/delete-redchrip-subscription-agreement-signatures-for-org',
        
          'params' : {
              'organization_id': this.profile.organization_account.organization_id,
            },
        
          'on_success': (data) => {
              this.$emit('reload-profile');
            },
        
          'on_error': 'Unable to delete subscription agreement signature.',
        });
      },

      onClickTCRCampaignRegistration()
      {
        this.$router.push({
          'name': 'welcome_admin_tcr_campaign_registration',
          'params' : {
            'organization_id': this.profile.organization_account.organization_id,
          }
        });
      },

      onClickMonday()
      {
        window.open('https://redchirp.monday.com/boards/3061858207', '_blank')
      },

      

      onClickToDo(item)
      {
        if ( item.state_override )
        {
          this.onClickClearConfirmation(item);
          return;
        }

        this.$rc.confirm({
          'title': item.confirm_title,
          'body': item.confirm_text,
          'btn_text_ok': 'Confirm',
          'btn_text_cancel': 'Cancel',
          'on_ok': () => {
            this.$rc.rest({
              'spinner': false,
              'endpoint': 'PUT: /api/v1/welcome/tasks/override',
            
              'params' : {
                  'organization_id': this.profile.organization_account.organization_id,
                  'type': item.type,
                  'state': 'done'
                },
            
              'on_success': (data) => {
                  this.$emit('reload-profile');
                },
            
              'on_error': 'Unable to update ToDo',
            });
          },
        });
      },

      onClickClearConfirmation(item)
      {
        this.$rc.confirm({
          'title': 'Undo Confirmation',
          'body': 'Undo the confirmation of this todo?',
          'btn_text_ok': 'Undo',
          'btn_text_cancel': 'Cancel',
          'on_ok': () => {
            this.$rc.rest({
              'spinner': false,
              'endpoint': 'DELETE: /api/v1/welcome/tasks/override',
            
              'params' : {
                  'organization_id': this.profile.organization_account.organization_id,
                  'type': item.type
                },
            
              'on_success': (data) => {
                  this.$emit('reload-profile');
                },
            
              'on_error': 'Unable to undo confirm ToDo',
            });
          },
        });
      }
    },
}
</script>

<style lang="scss" scoped>

</style>